// ─────────────────────────────────────────────────────────────────────────
// Tokens de diseño del back office — FUENTE ÚNICA de la paleta (consola CLARA).
//
// Derivados de la marca Yieldbox (brand book): Noche #191919, Marfil #EAEAEA,
// Ultramarino #282A33. La consola es CLARA (marfil/blanco) con texto Noche,
// austera y geométrica. El color cromático se reserva para ESTADO
// (pendiente/éxito/rechazo) y NIVEL de membresía; el acento de acción es un
// slate-azul profundo (ultramarino), no un neón.
//
// Los usan el theme de MUI (core/theming) y los componentes del chrome y las
// fichas. No hay otra definición de color: si algo necesita un tono, sale de acá.
// ─────────────────────────────────────────────────────────────────────────

export const tokens = {
  // Superficies — escala clara entre Marfil y blanco, para estratificar.
  bg: '#EDEDEB', // fondo de la app (marfil suave)
  surface: '#F6F6F4', // sidebar / superficie base
  card: '#FFFFFF', // tarjetas y app bar (blanco)
  card2: '#F1F1EF', // elevado: inputs, hover de fila (gris muy claro)
  card3: '#E6E6E3', // elevado 2: chips, bordes activos

  // Líneas (hairlines de Noche con baja opacidad).
  line: 'rgba(28, 29, 33, 0.10)',
  lineStrong: 'rgba(28, 29, 33, 0.16)',

  // Texto (oscuro, sobre claro).
  text: '#1C1D21', // Noche (texto principal)
  textDim: '#545A66', // pizarra media (labels, secundario)
  faint: '#868D99', // pizarra apagada (terciario, placeholders)

  // Acento de acción / interacción (slate-azul profundo, se nota sobre claro).
  accent: '#3E4A62', // ultramarino: activo, links, foco
  accentDim: '#6C7689',
  onAccent: '#FFFFFF', // texto sobre el botón oscuro (Noche)

  // Estados — funcionales y desaturados (encoding, no decoración), oscurecidos
  // para que contrasten sobre claro.
  pending: '#A9761F', // oro
  success: '#2F8158', // verde
  error: '#BB4A3A', // terracota
  info: '#3D6D95',

  // Niveles de membresía — pizarra con matiz (disciplina de marca), oscurecidos
  // para leerse sobre claro.
  tierBasic: '#6A727F',
  tierPremium: '#46506A', // slate
  tierElite: '#94781F', // champagne/oro oscuro (coincide con XAU)
  tierUltra: '#6B5DA0', // violeta profundo: VIP manual (tierOverride)
} as const;

// Mezcla un hex con opacidad → rgba(). Para velos suaves de chips/fondos.
export function withAlpha(hex: string, alpha: number): string {
  let h = hex.replace('#', '');
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  let r = parseInt(h.slice(0, 2), 16);
  let g = parseInt(h.slice(2, 4), 16);
  let b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Familias tipográficas (cargadas en public/index.html).
export const fonts = {
  // Geométrica, elegante y legible: evoca la Aventa de la marca sin depender de
  // su licencia (pendiente). Una sola familia para todo el chrome y los datos;
  // el peso y el tracking hacen la jerarquía.
  sans: "'Outfit', 'Segoe UI', system-ui, -apple-system, sans-serif",
  // Monoespaciada para datos técnicos: UIDs, direcciones, expresiones cron, IDs.
  mono: "'JetBrains Mono', 'Roboto Mono', ui-monospace, SFMono-Regular, monospace",
} as const;
